module.exports = __webpack_public_path__ + "media/angelic_recruit.77d0b2aa.webm";